import React from 'react';

import './styles.css';

interface ArrivalRoomCheckProps {
  roomNumber: string;
  roomType: string;
}

interface ArrivalRoomCheckBasicInformationProps {
  arrivalRoomCheck: ArrivalRoomCheckProps;
}

class ArrivalRoomCheckBasicInformation extends React.Component<
  ArrivalRoomCheckBasicInformationProps
> {
  render() {
    const {arrivalRoomCheck: {roomNumber, roomType}} = this.props;

    return (
      <div className="ArrivalRoomCheckBasicInformation colab-centered-v colab-sidepadding-2">
        <div>
          <div className="ArrivalRoomCheckBasicInformation--label colab-bold">
            Room
          </div>
          <div className="ArrivalRoomCheckBasicInformation--value">
            {roomNumber}
          </div>
        </div>
        <div>
          <div className="ArrivalRoomCheckBasicInformation--label colab-bold">
            Room type
          </div>
          <div className="ArrivalRoomCheckBasicInformation--value">
            {roomType}
          </div>
        </div>
      </div>
    );
  }
}

export default ArrivalRoomCheckBasicInformation;
